module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "foo"
  }, [_c('H1', [_vm._v(_vm._s(_vm.locale.t("label_trainings_report")))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "training-report-date-row"
  }, [_c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_from")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fromDate),
      expression: "fromDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.fromDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fromDate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('span', [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.locale.t("label_to")) + ":")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.toDate),
      expression: "toDate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input date-input-sm",
    attrs: {
      "type": "date",
      "placeholder": "Do",
      "name": "email"
    },
    domProps: {
      "value": (_vm.toDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.toDate = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.role === 'ROLE_SUPER_ADMIN' || _vm.role === 'ROLE_ADMIN') ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "scrollmenu"
  }, [_vm._l((_vm.partners), function(item) {
    return _c('span', [_c('span', {
      staticClass: "chips-group clickable",
      attrs: {
        "value": ""
      },
      on: {
        "click": function($event) {
          return _vm.clickSelectPartner(item)
        }
      }
    }, [_c('span', {
      staticClass: "single-chip"
    }, [_c('span', {
      class: _vm.getChipClass(item)
    }, [_vm._v(_vm._s(_vm.isSelected(item) ? '✔ ' : '') + _vm._s(item))])])]), _vm._v(" \n              ")])
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 2), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "form-control input",
    attrs: {
      "type": "text",
      "placeholder": _vm.locale.t('label_search'),
      "name": "trainings"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "keyup": _vm.keymonitor,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.slotsPerDay.length > 0) ? _c('div', {
    staticClass: "training-report-slot-filter training-report-slot-filter--compact training-report-slot-filter--center"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.slotFilter),
      expression: "slotFilter"
    }],
    staticClass: "training-report-slot-filter__select",
    attrs: {
      "name": "slot_filter"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.slotFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    key: -1,
    attrs: {
      "value": "-1"
    }
  }), _vm._v(" "), (_vm.usersCanReserveTrainingWithScanQr) ? _c('option', {
    key: -2,
    attrs: {
      "value": "-2"
    }
  }, [_vm._v(_vm._s(_vm.locale.t('label_qr_code_training_type')))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredSlots), function(slot) {
    return _c('option', {
      key: slot.id,
      domProps: {
        "value": slot.id
      }
    }, [_vm._v("\n            " + _vm._s(slot.startAt) + "-" + _vm._s(slot.trainingType) + "\n          ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "report-muted training-report-slot-filter__note"
  }, [_c('i', [_vm._v(_vm._s(_vm.locale.t('label_desc_training_filter_on_report')) + " (" + _vm._s(_vm.formatDate(_vm.fromDate)) + ")")])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.clickSearch
    }
  }, [_c('i', {
    staticClass: "ti-search"
  }), _vm._v(" " + _vm._s(_vm.locale.t('label_do_search')))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showVegaReport) ? _c('span', [_c('div', {
    staticClass: "new-button",
    on: {
      "click": _vm.loadPaymentByCompany
    }
  }, [_c('i', {
    staticClass: "ti-download"
  }), _vm._v(" Vega IT doo")])]) : _vm._e(), _vm._v(" "), (_vm.partnerCompanies.length > 0) ? _c('div', _vm._l((_vm.partnerCompanies), function(item) {
    return _c('span', [_c('div', {
      staticClass: "new-button",
      on: {
        "click": function($event) {
          return _vm.loadPaymentByPartnerCompany(item.name)
        }
      }
    }, [_c('i', {
      staticClass: "ti-download"
    }), _vm._v(" " + _vm._s(item.name))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "report-toggle-label training-weekly-toggle",
    on: {
      "click": function($event) {
        return _vm.showWeeklyReport()
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.locale.t('label_show_weekly_report')))]), _vm._v(" "), _c('i', {
    class: _vm.weeklyReport ? 'ti-arrow-circle-up' : 'ti-arrow-circle-down'
  })]), _vm._v(" "), (_vm.weeklyReport && !_vm.loadingWeeklyReport) ? _c('div', {
    staticClass: "training-weekly-report"
  }, _vm._l((_vm.slots), function(item, dayIdx) {
    return _c('article', {
      key: 'weekly-day-' + item.date + '-' + dayIdx,
      staticClass: "training-weekly-day"
    }, [_c('header', {
      staticClass: "training-weekly-day__head"
    }, [_c('div', {
      staticClass: "training-weekly-day__date"
    }, [_vm._v(_vm._s(item.date))]), _vm._v(" "), _c('div', {
      staticClass: "training-weekly-day__count"
    }, [_vm._v(_vm._s((item.trainings || []).length))])]), _vm._v(" "), _c('ul', {
      staticClass: "training-weekly-day__list"
    }, _vm._l((item.trainings), function(element, slotIdx) {
      return _c('li', {
        key: 'weekly-slot-' + item.date + '-' + slotIdx,
        staticClass: "training-weekly-day__item"
      }, [_c('span', {
        staticClass: "training-weekly-day__time"
      }, [_vm._v(_vm._s(element.startAt))]), _vm._v(" "), (_vm.showTrainingType) ? _c('span', {
        staticClass: "training-weekly-day__type"
      }, [_vm._v(_vm._s(element.trainingType))]) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "training-weekly-day__arrow"
      }, [_vm._v("→")]), _vm._v(" "), _c('span', {
        staticClass: "training-weekly-day__value"
      }, [_vm._v(_vm._s(element.numberOfTrainings))])])
    }), 0)])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.weeklyReport && !_vm.loadingWeeklyReport && _vm.slots.length === 0) ? _c('div', {
    staticClass: "training-weekly-empty"
  }, [_vm._v("\n      😐 " + _vm._s(_vm.locale.t('label_no_weekly_report_data')) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.weeklyReport && _vm.loadingWeeklyReport) ? _c('my-loader', {
    staticClass: "centered-div"
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.showTotalPrice) ? _c('div', {
    staticClass: "training-report-finance"
  }, [_c('div', {
    staticClass: "training-report-finance__item"
  }, [_c('div', {
    staticClass: "training-report-finance__label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_amount')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-finance__value"
  }, [_vm._v(_vm._s(parseFloat(_vm.totalPrice.toString()).toFixed(0)) + " " + _vm._s(_vm.locale.t("label_currency")))])]), _vm._v(" "), _c('div', {
    staticClass: "training-report-finance__item"
  }, [_c('div', {
    staticClass: "training-report-finance__label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_number_of_terms')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-finance__value"
  }, [_vm._v(_vm._s(_vm.totalSlots))])]), _vm._v(" "), _c('div', {
    staticClass: "training-report-finance__item"
  }, [_c('div', {
    staticClass: "training-report-finance__label"
  }, [_vm._v(_vm._s(_vm.locale.t('label_average')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-finance__value"
  }, [_vm._v(_vm._s(parseFloat((_vm.totalPrice / _vm.totalSlots).toString()).toFixed(0)) + " " + _vm._s(_vm.locale.t("label_currency")))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "training-report-charts"
  }, [_c('div', {
    staticClass: "training-report-charts__summary"
  }, [_c('div', [_c('div', {
    staticClass: "training-report-charts__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_total_reservations')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-charts__kpi-value"
  }, [_vm._v(_vm._s(_vm.reservationSummary.totalReservations))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "training-report-charts__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_most_popular_term')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-charts__kpi-value"
  }, [_vm._v(_vm._s(_vm.popularTermLabel))])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "training-report-charts__kpi-title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_most_popular_term_reservations')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-charts__kpi-value"
  }, [_vm._v(_vm._s(_vm.popularTermReservations))])])]), _vm._v(" "), (!_vm.reservationSummaryLoading) ? _c('div', {
    staticClass: "training-report-charts__grid"
  }, [_c('article', {
    staticClass: "training-report-chart"
  }, [_c('header', {
    staticClass: "training-report-chart__head"
  }, [_c('div', {
    staticClass: "training-report-chart__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_most_popular_terms')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-chart__meta"
  }, [_vm._v(_vm._s(_vm.popularTermsChart.length))])]), _vm._v(" "), (_vm.popularTermsChart.length) ? _c('div', {
    staticClass: "training-report-chart__rows"
  }, _vm._l((_vm.popularTermsChart), function(item, idx) {
    return _c('div', {
      key: 'pop-' + _vm.chartLabel(item) + '-' + idx,
      staticClass: "training-report-chart__row"
    }, [_c('div', {
      staticClass: "training-report-chart__label",
      attrs: {
        "title": _vm.chartLabel(item)
      }
    }, [_vm._v(_vm._s(_vm.chartLabel(item)))]), _vm._v(" "), _c('div', {
      staticClass: "training-report-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "training-report-chart__bar training-report-chart__bar--popular",
      style: ({
        width: _vm.chartWidth(item.totalReservations, _vm.maxPopularReservations)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "training-report-chart__value"
    }, [_vm._v(_vm._s(item.totalReservations))])])
  }), 0) : _c('div', {
    staticClass: "training-report-chart__empty"
  }, [_vm._v("😐 " + _vm._s(_vm.locale.t('label_nothing_found')))])]), _vm._v(" "), _c('article', {
    staticClass: "training-report-chart"
  }, [_c('header', {
    staticClass: "training-report-chart__head"
  }, [_c('div', {
    staticClass: "training-report-chart__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_term_occupancy')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-chart__meta"
  }, [_vm._v("%")])]), _vm._v(" "), (_vm.occupancyTermsChart.length) ? _c('div', {
    staticClass: "training-report-chart__rows"
  }, _vm._l((_vm.occupancyTermsChart), function(item, idx) {
    return _c('div', {
      key: 'occ-' + _vm.chartLabel(item) + '-' + idx,
      staticClass: "training-report-chart__row"
    }, [_c('div', {
      staticClass: "training-report-chart__label",
      attrs: {
        "title": _vm.chartLabel(item)
      }
    }, [_vm._v(_vm._s(_vm.chartLabel(item)))]), _vm._v(" "), _c('div', {
      staticClass: "training-report-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "training-report-chart__bar training-report-chart__bar--occupancy",
      style: ({
        width: Math.max(8, Number(item.fullSlotsPercent || 0)) + '%'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "training-report-chart__value"
    }, [_vm._v(_vm._s(_vm.formatPercent(item.fullSlotsPercent)) + "%")])])
  }), 0) : _c('div', {
    staticClass: "training-report-chart__empty"
  }, [_vm._v("😐 " + _vm._s(_vm.locale.t('label_nothing_found')))])]), _vm._v(" "), _c('article', {
    staticClass: "training-report-chart"
  }, [_c('header', {
    staticClass: "training-report-chart__head"
  }, [_c('div', {
    staticClass: "training-report-chart__title"
  }, [_vm._v(_vm._s(_vm.locale.t('label_full_terms')))]), _vm._v(" "), _c('div', {
    staticClass: "training-report-chart__meta"
  }, [_vm._v(_vm._s(_vm.alwaysFullChart.length))])]), _vm._v(" "), (_vm.alwaysFullChart.length) ? _c('div', {
    staticClass: "training-report-chart__rows"
  }, _vm._l((_vm.alwaysFullChart), function(item, idx) {
    return _c('div', {
      key: 'full-' + _vm.chartLabel(item) + '-' + idx,
      staticClass: "training-report-chart__row"
    }, [_c('div', {
      staticClass: "training-report-chart__label",
      attrs: {
        "title": _vm.chartLabel(item)
      }
    }, [_vm._v("\n                " + _vm._s(_vm.chartLabel(item)) + "\n                "), _c('span', {
      staticClass: "training-report-chart__badge"
    }, [_vm._v(_vm._s(item.fullSlots) + "/" + _vm._s(item.totalSlots))])]), _vm._v(" "), _c('div', {
      staticClass: "training-report-chart__bar-wrap"
    }, [_c('div', {
      staticClass: "training-report-chart__bar training-report-chart__bar--full",
      style: ({
        width: _vm.chartWidth(item.totalReservations, _vm.maxAlwaysFullReservations)
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "training-report-chart__value"
    }, [_vm._v(_vm._s(item.totalReservations))])])
  }), 0) : _c('div', {
    staticClass: "training-report-chart__empty"
  }, [_vm._v("😐 " + _vm._s(_vm.locale.t('label_nothing_found')))])])]) : _vm._e(), _vm._v(" "), (_vm.reservationSummaryLoading) ? _c('div', {
    staticClass: "training-report-chart__loading"
  }, [_c('my-loader', {
    staticClass: "centered-div"
  })], 1) : _vm._e()]), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content table-responsive table-full-width"
  }, [_c('table', {
    staticClass: "table-main table-main--fixed"
  }, [_c('thead', [_c('tr', [(_vm.useProfilePictures) ? _c('th', {
    staticStyle: {
      "width": "100px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_picture")))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_name")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_surname")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_time")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_date")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_rest_trainings")))]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_training_type_title")))]), _vm._v(" "), (_vm.shouldApproveReservedTraining) ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_approved")) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.showUserTrainingTypeOnTraining) ? _c('th', {
    staticStyle: {
      "width": "300px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_user_training_type")))]) : _vm._e(), _vm._v(" "), (_vm.showAddKeyForTraining) ? _c('th', {
    staticStyle: {
      "width": "200px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_training_key")))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "400px"
    }
  }, [_vm._v(_vm._s(_vm.locale.t("label_partner")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.trainings), function(training) {
    return _c('tr', [(_vm.useProfilePictures) ? _c('td', {
      staticClass: "clickable",
      attrs: {
        "data-title": _vm.locale.t('label_picture')
      }
    }, [(training.profilePicture != null && training.profilePicture.length > 0) ? _c('img', {
      staticClass: "cropped1 user-avatar-sm",
      attrs: {
        "src": training.profilePicture
      },
      on: {
        "click": function($event) {
          return _vm.openImage(training.profilePicture, training.userId)
        }
      }
    }) : _vm._e(), _vm._v(" "), (training.profilePicture == null || training.profilePicture.length === 0) ? _c('img', {
      staticClass: "cropped1-missing user-avatar-sm",
      attrs: {
        "src": require("../../assets/img/icons/missing_image.svg")
      },
      on: {
        "click": function($event) {
          return _vm.openImage('', training.userId)
        }
      }
    }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_name')
      }
    }, [_vm._v(_vm._s(training.firstName) + " "), (_vm.showTotalPrice) ? _c('b', [_vm._v("(" + _vm._s(training.trainingPrice) + "\n              din)")]) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_surname')
      }
    }, [_vm._v(_vm._s(training.lastName))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_time')
      }
    }, [_vm._v(_vm._s(training.startAt))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_date')
      }
    }, [_vm._v(_vm._s(training.date))]), _vm._v(" "), (_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_rest_trainings')
      }
    }, [_vm._v("\n              " + _vm._s(training.restOfTrainings) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_training_type_title')
      }
    }, [_vm._v(_vm._s(training.trainingType))]), _vm._v(" "), (_vm.shouldApproveReservedTraining) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_approved')
      }
    }, [(training.checkedByQr === true) ? _c('img', {
      staticClass: "icon-sm",
      attrs: {
        "src": require("../../assets/img/icons/ic_checked.svg")
      }
    }) : _vm._e(), _vm._v(" "), (training.checkedByQr == null || training.checkedByQr === false) ? _c('img', {
      staticClass: "icon-sm-clickable",
      attrs: {
        "src": require("../../assets/img/icons/ic_unchecked.svg")
      },
      on: {
        "click": function($event) {
          return _vm.approveTraining(training, true)
        }
      }
    }) : _vm._e(), _vm._v(" "), (training.checkedByQr == null || training.checkedByQr === false) ? _c('div', [_c('a', {
      staticClass: "clickable",
      on: {
        "click": function($event) {
          return _vm.approveTraining(training, true)
        }
      }
    }, [_vm._v(_vm._s(_vm.locale.t('label_approve')))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showUserTrainingTypeOnTraining) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_user_training_type')
      }
    }, [_vm._v(_vm._s(training.userTrainingType != null ? training.userTrainingType : '/'))]) : _vm._e(), _vm._v(" "), ((_vm.role === 'ROLE_ADMIN' || _vm.role === 'ROLE_SUPER_ADMIN') && _vm.showAddKeyForTraining) ? _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_training_key')
      }
    }, [(training.key.length > 0) ? _c('p', [_vm._v(_vm._s(training.key))]) : _vm._e(), _vm._v(" "), (training.key.length <= 0) ? _c('p', [_vm._v("/")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-title": _vm.locale.t('label_partner')
      }
    }, [_vm._v("\n              " + _vm._s(training.paymentCompany === null || training.paymentCompany.length === 0 ? '/' : training.paymentCompany) + "\n            ")])])
  }), 0)])])])]), _vm._v(" "), (_vm.pagination.totalCount > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "active-page": _vm.pagination.page,
      "total": _vm.pagination.totalCount,
      "limit": _vm.pagination.limit
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('show-image-dialog', {
    attrs: {
      "show": _vm.showImagePreview,
      "image": _vm.imageToPreview,
      "userId": _vm.imageToPreviewUserId
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fc6ab78!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TrainingReport/TrainingReport.vue
// module id = 748
// module chunks = 0